import React from 'react';
import IconSVG from '@legacy/moon/particles/IconSVG';
import config from 'config';

import Icon from './styles';
import assets from './assets/index';
import { CurrencyIconProps } from './types';

const CurrencyIcon = (props: CurrencyIconProps): JSX.Element => {
  const { currency, path, margin, size, alt } = props;

  const source = assets[currency];

  if (source && !path) {
    const { src } = source;
    return <Icon size={size} src={src} margin={margin} alt={alt} />;
  }

  const assetUrl = `${config.dynamicAssetsBaseURL}${path || `/assets/icon/${currency}.svg`}`;

  return <IconSVG alt={currency} name="genericAsset" url={assetUrl} margin={margin} size={size} />;
};

CurrencyIcon.defaultProps = {
  margin: '0',
  size: 24,
};

export default CurrencyIcon;
